<template>
  <checkout-layout>
    <div class="user-identification">
      <checkout-headline :title="$t('checkout.identifyUser.title')" :text="$t('checkout.identifyUser.text')"/>
      <user-identification-wrapper @update-component="updateComponent"/>
    </div>
  </checkout-layout>
</template>

<script>
import { checkoutViews } from '../config/checkoutViews'
import cartComponentsProps from '../config/cartComponentsProps'
import CheckoutHeadline from '@/components/checkout/checkout-headline'
import UserIdentificationWrapper from '@/components/checkout/user-identification/user-identification-wrapper'
import CheckoutLayout from '../checkout-layout'
import checkoutDataLayer from '../mixins/checkoutDataLayer'

export default {
  name: 'user-identification',
  props: { ...cartComponentsProps },
  mixins: [checkoutDataLayer],
  components: { CheckoutLayout, CheckoutHeadline, UserIdentificationWrapper },

  methods: {
    updateComponent (payload) {
      let component
      if (payload === 'userIdentificationExisting') {
        component = checkoutViews.userIdentificationExisting.name // 'userIdentificationExistingNumber'
      } else if (payload === 'new' && this.$props.cartData.tariffType === 'CABLE') {
        component = checkoutViews.userIdentificationNewCable.name
      } else if (payload === 'new' && this.$props.cartData.tariffType === 'MOBILE') {
        component = checkoutViews.userIdentificationFreeNumber.name
      }
      this.$emit('update-component', component, payload)
    }
  },
  mounted () {
    this.checkoutDataLayer(this.$props.cartData.entries, this.$props.step, '')
  }
}
</script>

<style lang="scss" scoped>
.user-identification {
  padding: 3.2rem 0 1.6rem;
  @media (map_get($breakpoints, sm)) {
    padding: 13.6rem 0;
  }

  @media (map_get($breakpoints, md)) {
    padding: 4rem 0 7rem;
  }

  @media (map_get($breakpoints, xxl)) {
    padding: 16rem 0;
  }
}
</style>
